<template>
<e-chart ref="chart" />
</template>

<script>
// import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
export default {
  name: 'AirQualityCalendarChart',
  props: {
    data: {
      required: true,
      type: Array
    }
    // screenWidth: {
    //   required: true,
    //   type: Number
    // },
    // screenHeight: {
    //   required: true,
    //   type: Number
    // },
    // query: {
    //   required: true,
    //   type: Object
    // }
  },
  methods: {
    getHeatmapData () {
      let {data} = this

      return data.map((el, i) => {
        return {
          type: 'heatmap',
          coordinateSystem: 'calendar',
          calendarIndex: i,
          tooltip: {
            show: false
          },
          data: el.heatmapData
        }
      })
    },
    getLunarData () {
      let {data} = this

      return data.map((el, i) => {
        return {
          type: 'scatter',
          coordinateSystem: 'calendar',
          calendarIndex: i,
          label: {
            show: true,
            formatter: function (params) {
              return `${params.value[2]}`
            },
            fontSize: 10,
            color: '#000'
          },
          tooltip: {
            formatter: function (param) {
              return `${param.value[0]}<br />AQI: ${param.value[1] ? param.value[1] : '/'}<br />主要污染物：${param.value[2]}<br />${(param.value[2] === '--' || param.value[2] === '无') ? '' : param.value[2] + ': ' + param.value[3] + (param.value[2] === 'CO' ? '(mg/m³)' : '(μg/m³)')}`
            }
          },
          symbolSize: 0,
          data: el.lunarData
        }
      })
    },
    getCalendar () {
      let {data} = this
      return data.map((el, index) => {
        return {
          top: index === 0 ? 85 : index * 232 + 85,
          left: 55,
          orient: 'horizontal',
          height: 230,
          cellSize: 'auto',
          yearLabel: {
            show: true
          },
          dayLabel: {
            nameMap: 'cn'
          },
          monthLabel: {
            show: index === 0,
            nameMap: 'cn',
            margin: 5
          },
          range: el.year
        }
      })
    },
    render (isReal) {
      let chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        tooltip: {},
        visualMap: [{
          show: true,
          type: 'piecewise',
          orient: 'horizontal',
          seriesIndex: this.data.map((el, i) => i),
          pieces: [
            {min: 300, color: '#7E0024'},
            {min: 200, max: 300, color: '#99004C'},
            {min: 150, max: 200, color: '#FF0000'},
            {min: 100, max: 150, color: '#FF7E00'},
            {min: 50, max: 100, color: '#FFFF00'},
            {min: 0, max: 50, color: '#00EE00'}
          ],
          left: 'center',
          top: 30
        }],
        calendar: this.getCalendar(),
        series: this.getHeatmapData().concat(this.getLunarData())
      }

      this.$refs.chart.setOpt(chartOpt)
      this.$refs.chart.resize()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/AirQualityCalendarChart.vue